import React from 'react';
import MuiTableRow from '@mui/material/TableRow';

const TableRow = (props) => <MuiTableRow {...props} />;

export default TableRow;
